<div class="container-fluid" style="font-size: 14px;">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <h2 class="title" *ngIf="type==='external_supplier'">{{isEdit ? 'Edit Supplier' : 'Add new Supplier'}}</h2>
    <h2 class="title" *ngIf="type!=='external_supplier'">{{isEdit ? 'Edit Internal User' : 'Add new Internal User'}}</h2>
    <div class="btn btn-primary d-flex justify-content-center align-items-center btn-add button" (click)="submit()">Save
    </div>
  </div>
  <div [formGroup]="supplierForm">
    <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3">SSO
      <span style="color: red;">*</span>
    </div>
    <div class="col-12 p-0 row m-0">
      <mat-form-field floatLabel="never" appearance="outline" class="col-5 p-0">
        <input formControlName="sso" name="sso" matInput placeholder="" style="color: #18181a;">
        <mat-hint align="end">{{supplierForm.controls.sso.value.length || 0}} / 50</mat-hint>
        <mat-error>{{supplierForm.controls.sso.errors?.message}}</mat-error>
      </mat-form-field>
      <div class="col-2 p-0 d-flex justify-content-center align-items-center">
        <button class="btn btn-primary button" (click)="search()"
          style="height: 43px; margin-top: -9px; width: 100px;">Search</button>
      </div>
    </div>
    <div class="row m-0">
      <div class="col-xl-6 col-md-6 col-sm-6 p-0">
        <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3">Full Name
        </div>
        <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 disabled-input">
          <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
            <input formControlName="fullName" name="fullName" matInput readonly>
          </mat-form-field>
        </div>
      </div>
      <div class="col-xl-6 col-md-6 col-sm-6 p-0">
        <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 pt-3 ml-auto">Email
        </div>
        <div class="col-xl-10 col-md-10 col-sm-12 col-12 p-0 ml-auto disabled-input">
          <mat-form-field floatLabel="never" appearance="outline" class="col-12 p-0">
            <input formControlName="email" name="email" matInput readonly>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row m-0">
      <div class="col-xl-6 col-md-6 col-sm-6 p-0 mb-3">
        <div class="col-2 d-flex flex-column p-0">Supplier Portal Access
          <mat-checkbox formControlName="rspAccess" name="rspAccess" style="margin-top: 10px;"></mat-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!isInternal">
    <h5 class="table-title">SRM Supplier</h5>
    <table class="w-100">
      <tr class="header">
        <th style="width: 20%">GSL Number</th>
        <th style="width: 30%;">Supplier Name</th>
        <th style="width: 40%;">Parent Company Name</th>
        <th style="width: 10%;" class="text-center">Action</th>
      </tr>
      <tr *ngFor="let item of listInfo; let i = index" disabled>
        <td>
          <app-autocomplete-input [model]="item.gslNumber" [maxLength]="6" [data]="listGSLNumber" [isSubmit]="isSubmit"
            (value)="getGSLData($event, 'gslNumber')" (autoComplete)="setAutoComplete($event, 'gslNumber', i)"
            [disabled]="!item.isEdit" [required]="true" (enterManual)="setManual($event, 'gslNumber', i)"
            [name]="'gslNumber'">
          </app-autocomplete-input>
        </td>
        <td>
          <app-autocomplete-input [model]="item.supplierName" [maxLength]="100" [data]="listSupplierName"
            [isSubmit]="isSubmit" (value)="getGSLData($event, 'supplierName')"
            (autoComplete)="setAutoComplete($event, 'supplierName', i)" [disabled]="!item.isEdit" [required]="true"
            (enterManual)="setManual($event, 'supplierName', i)" [name]="'supplierName'"></app-autocomplete-input>
        </td>
        <td>
          <app-autocomplete-input [model]="item.parentCompanyName" [maxLength]="100" [data]="listParentCompanyName"
            [isSubmit]="isSubmit" (value)="getGSLData($event, 'parentCompanyName')"
            (autoComplete)="setAutoComplete($event, 'parentCompanyName', i)" [disabled]="!item.isEdit"
            [required]="false" (enterManual)="setManual($event, 'parentCompanyName', i)" [name]="'parentCompanyName'">
          </app-autocomplete-input>
        </td>
        <td style="text-align: center;">
          <i class="fa fa-trash px-2 action delete" aria-hidden="true" [matTooltip]="'Remove'" (click)="deleteItem(i)"
            style="cursor: pointer; font-size:23px"></i>
        </td>
      </tr>
    </table>
    <button class="btn btn-outline-primary btn-add mt-2" (click)="addNew()">+ ADD</button>

    <h5 class="table-title mt-4">EOL Supplier</h5>
    <table class="w-100">
      <tr class="header">
        <th style="width: 20%">GSL Number</th>
        <th style="width: 30%;">Supplier Name</th>
        <th style="width: 20%;">Destruction</th>
        <th style="width: 20%;">Recycling</th>
        <th style="width: 10%;" class="text-center">Action</th>
      </tr>
      <tr *ngFor="let item of listEOLInfo; let i = index" disabled>
        <td>
          <app-autocomplete-input [model]="item.gslNumber" [maxLength]="6" [data]="listEOLGSLNumber" [isSubmit]="isSubmit"
            (value)="onEOLGslChange($event, i)" (autoComplete)="setEOLAutoComplete($event, 'gslNumber', i)"
            [disabled]="false" [required]="true" (enterManual)="setManualEOL($event, 'gslNumber', i)"
            [name]="'eolGslNumber'">
          </app-autocomplete-input>
        </td>
        <td>
          <mat-form-field floatLabel="never" appearance="outline" class="col-11 p-0">
            <mat-select [(ngModel)]="item.supplierName" [disabled]="false"
              (selectionChange)="onEOLSupplierNameChange($event.value, i)">
              <mat-option *ngIf="eolSupplierNameOptions.length === 0" disabled>No records found</mat-option>
              <mat-option *ngFor="let name of eolSupplierNameOptions" [value]="name">
                {{ name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
        <td>
          <mat-form-field floatLabel="never" appearance="outline" class="col-11 p-0 disabled-input-form">
            <input matInput [value]="item?.destruction || null" readonly disabled>
          </mat-form-field>
        </td>
        <td>
          <mat-form-field floatLabel="never" appearance="outline" class="col-11 p-0 disabled-input-form">
            <input matInput [value]="item?.recycling || null" readonly disabled>
          </mat-form-field>
        </td>
        <td style="text-align: center;">
          <i class="fa fa-trash px-2 action delete" aria-hidden="true" [matTooltip]="'Remove'" (click)="deleteEOLItem(i)"
            style="cursor: pointer; font-size:23px"></i>
        </td>
      </tr>
    </table>
    <button *ngIf="listEOLInfo.length === 0" class="btn btn-outline-primary btn-add mt-2" (click)="addNewEOL()">+ ADD</button>
  </div>
</div>
